import { useTableActionContext } from '@aibees/elephant/context/table-action/context';
import { useMemo } from 'react';
import { SearchModality } from '../feature/search-table-company/hooks/types';
import { SearchTable, SearchType } from '../types';
import {
  useSearchRouteInfo,
  useSearchSimilarityFromRoute,
} from './use-obtain-search-type-from-route';

export function useGetCreditsAmountTypeOnActionPopup() {
  const { table } = useSearchRouteInfo();
  // Use the flow's effective search type / modality (both fold in the single-record
  // override) so credit types follow the record, not just the page route — e.g. a
  // person opened from the employees sidebar on a company search page.
  const { effectiveSearchType, effectiveModality } = useTableActionContext();
  // Store-backed now (see useSearchSimilarityFromRoute) — similarity `value` lives
  // in the scoped store, not the URL, so AI searches are detected on the tables.
  const isSimilarity = useSearchSimilarityFromRoute();

  return useMemo(() => {
    const isCompany = effectiveSearchType === SearchType.Company;
    const isPeople = effectiveSearchType === SearchType.People;
    const isCompanyEmployees = table === SearchTable.Employees;
    const isPeopleOrEmployees = isPeople || isCompanyEmployees;
    const isPeopleModality = !!effectiveModality;
    const isUnsavedModality = effectiveModality === SearchModality.UNSAVED;

    // If these flags are indeed always true, we can omit them.
    const basicCompany = !isSimilarity && isCompany;
    const aiCompany = isSimilarity && isCompany;
    const basicPeople =
      isPeopleOrEmployees &&
      !isSimilarity &&
      (!isPeopleModality || !isUnsavedModality);
    const aiPeople =
      isPeopleOrEmployees &&
      isSimilarity &&
      (!isPeopleModality || !isUnsavedModality);
    const basicUnsavedPeople =
      isPeopleOrEmployees &&
      !isSimilarity &&
      isPeopleModality &&
      isUnsavedModality;
    const aiUnsavedPeople =
      isPeopleOrEmployees &&
      isSimilarity &&
      isPeopleModality &&
      isUnsavedModality;

    return {
      basicCompany,
      aiCompany,
      basicPeople,
      aiPeople,
      basicUnsavedPeople,
      aiUnsavedPeople,
    };
  }, [effectiveSearchType, table, isSimilarity, effectiveModality]);
}
